// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__IW7bY","actions":"GroupTable_actions__3RUuC","deleteModalFooter":"GroupTable_deleteModalFooter__16bEJ"};